import { useState, useRef } from "react";
import _ from "lodash";

const useDebouncedState = <T>(initialValue: T, delay: number) => {
  const [state, setState] = useState<T>(initialValue);
  const debouncedSetState = useRef(_.debounce(setState, delay)).current;

  return [state, debouncedSetState] as const;
};

export default useDebouncedState;
